import { AttachmentKindIcon } from 'src/pages/Conversations/SidePanel/ConversationDetails/Attachments/attachment-kind-icon';
import type { AttachmentPillModel } from 'src/pages/Conversations/SidePanel/ConversationDetails/Attachments/attachment-utils';
import {
  PillHoverCardInfoRow,
  PillHoverCardTitle,
} from 'src/pages/Conversations/SidePanel/ConversationDetails/properties/pill-hover-card';

type AttachmentHoverCardProps = Pick<AttachmentPillModel, 'fileName' | 'kind' | 'displayDate'>;

export const AttachmentHoverCard = ({
  fileName,
  kind,
  displayDate,
}: AttachmentHoverCardProps) => (
  <>
    <PillHoverCardTitle wrap leading={<AttachmentKindIcon kind={kind} size={15} />}>
      {fileName}
    </PillHoverCardTitle>
    <PillHoverCardInfoRow icon="calendar">{displayDate}</PillHoverCardInfoRow>
  </>
);
